import { SGBase, SGBaseProps, OptionalColor, FillOptionalColor } from './sgbase';
import bind from 'bind-decorator';
import { SgNode, TraversalState, BuildSgNodeReturn } from './sgproto';
import { Color } from '../utils/transform';

interface TintProps extends SGBaseProps
{
	color: Color | string;
}

export class Tint extends SGBase<TintProps, null>
{
	constructor( props: any )
	{
		super( props );
		super.setBuildNodeOverride( this.buildNode );
	}

	public getNodeType(): string
	{
		return "tint";
	}

	@bind private buildNode( traversalState: TraversalState, domNode: HTMLElement ): BuildSgNodeReturn
	{
		const node = this.createSgNode( domNode );

		if ( !this.props.color )
		{
			node.properties.color = [1, 1, 1];
		}
		else if ( typeof this.props.color == "string" )
		{
			node.properties.color = this.props.color;
		}
		else
		{
			let color = FillOptionalColor( this.props.color, { r: 1, g: 1, b: 1 } );
			node.properties.color = [color.r, color.g, color.b];
		}

		return [traversalState, node];
	}
}

